import { css } from '@/styled-system/css';

export const container = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'default',
});

export const faqItem = css({
  borderTopWidth: 'default',
  borderTopStyle: 'solid',
  borderTopColor: 'border.neutral',
  paddingTop: 'default',
  paddingBottom: 'default',
  '&:first-of-type': {
    borderTopWidth: 0,
    paddingTop: 0,
  },
  '&[open] > summary': {
    marginBottom: 'tighter',
  },
});

export const faqSummary = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 'default',
  cursor: 'pointer',
  listStyle: 'none',
  padding: 0,
  fontSize: 'body',
  lineHeight: 'body',
  color: 'text.neutral',
  fontWeight: 'bold',
  '&::-webkit-details-marker': {
    display: 'none',
  },
  '&::marker': {
    content: '""',
  },
  _focusVisible: {
    outlineWidth: 'thick',
    outlineStyle: 'solid',
    outlineColor: 'brand.primary',
    outlineOffset: '50',
    borderRadius: 'sm',
  },
});

export const caret = css({
  flexShrink: 0,
  color: 'text.neutral',
  transitionProperty: 'transform',
  transitionDuration: '200ms',
  transitionTimingFunction: 'ease',
  'details[open] &': {
    transform: 'rotate(180deg)',
  },
  '@media (prefers-reduced-motion: reduce)': {
    transitionDuration: '0ms',
  },
});

export const answerBody = css({
  fontSize: 'body',
  lineHeight: 'body',
  color: 'text.neutral',
  marginTop: 'tighter',
});

export const answerList = css({
  fontSize: 'body',
  lineHeight: 'body',
  color: 'text.neutral',
  marginTop: 'tighter',
  paddingLeft: 'loose',
  display: 'flex',
  flexDirection: 'column',
  gap: 'tightest',
});

export const answerListHeader = css({
  fontSize: 'body',
  lineHeight: 'body',
  color: 'text.neutral',
  marginTop: 'tighter',
});
